export const vision = {
label: 'STRATEGIC DIRECTION',
title: 'Strategic Direction',
subtitle: 'Guiding principles that drive our operations and business excellence.',
vision_title: 'Our Vision',
vision_text: 'To build a trusted company recognized for product quality, responsible growth, operational discipline, and long-term business relationships.',
mission_title: 'Our Mission',
mission_text: 'To provide quality wellness and personal care products through responsible direct sales, disciplined operations, sustainable market development, and strong relationships with customers, independent distributors, and business partners.',
pillars_title: 'Strategic Pillars',
pillar_1: 'Operational Excellence',
pillar_1_desc: 'Maintaining high operational standards and effective coordination across markets.',
pillar_2: 'Market Discipline',
pillar_2_desc: 'Executing market strategies with attention to regulatory compliance and operational efficiency.',
pillar_3: 'Product Quality',
pillar_3_desc: 'Delivering quality wellness products through strategic positioning and distribution.',
pillar_4: 'Sustainable Growth',
pillar_4_desc: 'Building scalable business structures that support long-term market presence and value.',
};
